import { Box, Flex, VizFooter } from '@ouster/webviz-react-components';

import { PiFolderLockFill } from 'react-icons/pi';
import { Outlet } from 'react-router';
import AdminSideNav from 'src/components/AdminSideNav';
import NavUser from 'src/components/users/NavUser';
import {
  FlexColumnWithNav,
  NavFullHeightContainer,
  NavFlexRow,
} from 'src/containers/NavBar';
import { useStoreState } from 'src/reducers';

export default function AdminDashboardLayoutV2() {
  const { curUserOrg, isOusterUser } = useStoreState(
    (storeState) => storeState.user
  );

  if (!curUserOrg) return null;

  return (
    <FlexColumnWithNav
      navRightEl={
        <NavFullHeightContainer>
          <NavFlexRow gap="16px">
            <NavUser />
          </NavFlexRow>
        </NavFullHeightContainer>
      }
    >
      {isOusterUser && curUserOrg.role !== 'BASIC' ? (
        <Box h="100%" display="grid" gridTemplateRows="1fr auto" minH={0}>
          {/*
            Keep the shell height-bound. A tall side nav must not stretch this
            row (that used to add a second page scrollbar). Nav and main each
            scroll in their own column.
          */}
          <Flex overflow="hidden" minH={0} h="100%">
            <Box
              w="min-content"
              h="100%"
              overflowY="auto"
              overflowX="hidden"
              bg="var(--ouster-colors-background-surface-subtle)"
              borderRight="1px solid"
              borderColor="var(--color-unify-white-30)"
              py={4}
              position="relative"
              flexShrink={0}
            >
              <AdminSideNav />
            </Box>
            <Box
              flex={1}
              minW={0}
              minH={0}
              h="100%"
              overflow="auto"
              bg="var(--color-gray-11)"
            >
              <Outlet />
            </Box>
          </Flex>
          <VizFooter
            mode="none"
            borderTop="1px solid"
            borderColor="var(--color-unify-white-10)"
            py="1em"
          />
        </Box>
      ) : (
        <Box
          fontSize={24}
          w="100%"
          h="100%"
          display="grid"
          placeContent="center"
          rowGap={8}
          justifyItems="center"
          data-testid="admin-dashboard-permission-denied"
        >
          <p>{`Sorry, you don't have the permission to view this page`}</p>
          <PiFolderLockFill size={72} />
        </Box>
      )}
    </FlexColumnWithNav>
  );
}
